import React, { useEffect } from "react";
import "./App.css";
import "./App.scss";
import ReactGA from "react-ga4";

import { Switch, Route, useParams } from "react-router-dom";

import { applyTheme } from "./lib/Theme";

import PublicPluginHost from "./components/PublicPluginHost/index.js";
import PublicPluginDetail from "./components/PublicPluginDetail/index.js";
import PluginCreator from "./components/PluginCreator/index.js";

import ToastWrapper from "./components/ToastWrapper/index.js";

function AppPublic() {
  const params = useParams();

  useEffect(() => {
    applyTheme("sorbet");
    ReactGA.initialize("G-ZXDVK9PG5W");
    window.edgetag("tag", "PageView");
  }, []);

  function openLogin() {
    // `slug` only exist in the context of a plugin page
    if (params.slug) {
      window.location.href = `https://editor.sudowrite.com?utm_source=website&utm_medium=plugins&utm_campaign=${params.slug}`;
    } else {
      window.location.href = "https://editor.sudowrite.com?utm_source=website&utm_medium=plugins";
    }
  }

  return (
    <ToastWrapper>
      <Switch>
      <Route
          path={["/plugin/:id/:slug", "/plugin/:id"]}
        >
          <PublicPluginDetail openLogin={openLogin} />
        </Route>

        <Route
          path={["/creator/:slug"]}
        >
          <PluginCreator openLogin={openLogin} />
        </Route>

        <Route
          path={["/search/:query", "/search/", "/category/:categorySlug", "/"]}
        >
          <PublicPluginHost openLogin={openLogin} />
        </Route>
      </Switch>
    </ToastWrapper>
  );
}

export default AppPublic;
